import React from "react";
import { Drawer } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography, IconButton, Divider } from "@mui/material";
import { IoMdClose } from "react-icons/io";

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 540,
    flexShrink: 0,
    p: 4,
  },
  drawerPaper: {
    width: 540,
    p: 4,
  },
  toolbar: theme.mixins.toolbar,
}));

const ZipCodeDetails = ({ open, onClose, data }) => {
  const classes = useStyles();

  const questionnaire = [
    {
      question: "Would You Like Mamaket To Be Available In Your City?",
      answer: data?.Interested,
    },
    {
      question: "What Best Describes You?",
      answer: data?.description,
    },
    {
      question: "Which Country’s Cultural Items Are You Most Interested In?",
      answer: data?.country?.name,
    },
    {
      question: "What types of items are you most interested in?",
      answer: data?.categories?.map((item) => item?.name),
    },
    {
      question: "Preferred email address?",
      answer: data?.email,
    },
    {
      question: "How Much Do You Currently Spend On Cultural Items?",
      answer: data?.currentSpend,
    },
    {
      question: "How Much Would You Prefer To Spend On Cultural Items?",
      answer: data?.preferredSpend,
    },
  ];

  return (
    <Drawer
      className={classes.drawer}
      anchor="right"
      open={open}
      onClose={onClose}
      classes={{ paper: classes.drawerPaper }}
    >
      <Box sx={{ px: 4, py: 5 }} className={classes.toolbar}>
        {/* Header */}
        <Box align="right">
          <IconButton onClick={onClose}>
            <IoMdClose style={{ fontSize: "20px", color: "#000" }} />
          </IconButton>
        </Box>
        <Typography
          sx={{
            fontFamily: "Lato",
            color: "#0D0D0D",
            fontSize: "14px",
            fontWeight: 600,
            mb: 3,
          }}
        >
          Zip Code Details
        </Typography>

        {/* Date, Zip, Location Block */}
        <Box
          sx={{
            background: "#FAFAFA",
            borderRadius: "10px",
            p: 2,
            mb: 2,
          }}
        >
          <Typography
            sx={{
              fontSize: "10px",
              fontWeight: 400,
              color: "#71717A",
              mb: 0.5,
            }}
          >
            Date
          </Typography>
          <Typography sx={{ fontWeight: 600, fontSize: "13px", mb: 1 }}>
            {new Date(data?.createdAt).toLocaleString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
            })}
          </Typography>

          <Typography
            sx={{
              fontSize: "10px",
              fontWeight: 400,
              color: "#71717A",
              mb: 0.5,
            }}
          >
            Zipcode
          </Typography>
          <Typography sx={{ fontWeight: 600, fontSize: "13px", mb: 1 }}>
            {data?.zipCode}
          </Typography>

          <Typography
            sx={{
              fontSize: "10px",
              fontWeight: 400,
              color: "#71717A",
              mb: 0.5,
            }}
          >
            City & State
          </Typography>
          <Typography sx={{ fontWeight: 600, fontSize: "13px" }}>
            {data?.country?.name}
          </Typography>
        </Box>

        {/* Questionnaire */}
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            border: "1px solid #F4F4F5",
            p: 2,
          }}
        >
          <Typography sx={{ fontWeight: 600, fontSize: "13px", mb: 2 }}>
            Questionnaire
          </Typography>

          {questionnaire.map((q, index) => (
            <Box key={index} sx={{ mb: 2 }}>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "12px",
                  lineHeight: "18px",
                  color: "#0F172A",
                }}
              >
                {q.question}
              </Typography>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "13px",
                  color: "#0F172A",
                  mt: 0.5,
                }}
              >
                {q.answer}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Drawer>
  );
};

export default ZipCodeDetails;
